module.exports = __webpack_public_path__ + "static/media/USA-Pennsylvania.5c1d0662.png";